

























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import Documento from "@/models/documento.model";
import TramiteBeneficiarioDocumento from "@/models/tramite/tramiteBeneficiarioDocumento.model";
import TipoTramiteDocumento from "@/models/tipoTramite/tipoTramiteDocumento.model";
import TipoTramiteNameValueDocumento from "@/models/tipoTramite/tipoTramiteNameValueDocumento.model";

@Component
export default class TipoTramiteNameValueDocumentoComponent extends BaseVue {
  @Prop() readonly tipoTramiteId!: number;
  @Prop() readonly nameValueId!: number;
  @Prop() readonly title!: string;
  @Prop() readonly refName!: string;
  @Prop() readonly refKey!: string;
  @Prop() readonly refValue!: string;

loading = false;
  tipoDocumentos: any[] = [];
  documentos: TramiteBeneficiarioDocumento[] = [];
  tipoTramiteDocRepo = new BaseRepository<TipoTramiteNameValueDocumento>(
    "tipoTramiteNameValueDocumento"
  );

  onSelectDoc(doc: Documento) {
    let found = this.tipoDocumentos.find(
      x => x.tipoDocumentoId === doc.tipoDocumentoId
    );
    found.fileSelected = doc;
    for (let index = 0; index < this.documentos.length; index++) {
      const x = this.documentos[index];
      if (x.tipoDocumentoId == doc.tipoDocumentoId) {
        this.documentos.splice(index, 1);
        break;
      }
    }
    let file = new TramiteBeneficiarioDocumento(
      doc.tipoDocumentoId,
      found.tipoDocumentoNombre
    );
    if (doc.id) file.documentoId = doc.id;
    else file.documento = doc;

    this.documentos.push(file);

    this.$emit("change", this.tipoDocumentos, this.documentos);
  }
  onRemoveDoc(doc: Documento) {
    let found = this.tipoDocumentos.find(
      x => x.tipoDocumentoId === doc.tipoDocumentoId
    );
    found.fileSelected = null;
    for (let index = 0; index < this.documentos.length; index++) {
      const x = this.documentos[index];
      if (x.tipoDocumentoId == doc.tipoDocumentoId) {
        this.documentos.splice(index, 1);
        break;
      }
    }
    this.$emit("change", this.tipoDocumentos, this.documentos);
  }

  //   @Watch("tipoTramiteId", { immediate: true })
  // async onTipoTramiteChange(value: number) {
  //   if (value && this.nameValueId) {
  //     let tipoDocumentos = await this.tipoTramiteDocRepo.many(`tipoTramiteId=${value}&&nameValueId=${this.nameValueId}`,"TipoDocumento|NameValue");
  //     this.tipoDocumentos = [];
  //     tipoDocumentos.forEach((x:any) => {
  //       let doc = this.copy(x);
  //       doc.fileSelected = null;
  //       this.tipoDocumentos.push(doc);
  //     });
  //   } else {
  //     this.tipoDocumentos = [];
  //   }
  // }
  async getData() {
    this.loading = true;
    let docs = await this.tipoTramiteDocRepo.many(
        `tipoTramiteId=${this.tipoTramiteId || null}&&nameValueId=${this.nameValueId || null}`,
        "TipoDocumento|NameValue"
      );
      this.tipoDocumentos = [];
      docs.forEach((x: any) => {
        let doc = this.copy(x);
        doc.fileSelected = null;
        this.tipoDocumentos.push(doc);
      });
       this.loading = false;
  }
  @Watch("nameValueId", { immediate: true })
  onNameValueChange(value: number) {
    this.getData()
  }

  getMissingRequiredDocuments() {
    return (this.tipoDocumentos || []).filter(
      x => x.requerido && !x.fileSelected
    );
  }

  public async isValid() {
    let isValid = await this.validateCurrentValidator();
    if (!isValid) return false;

    let missingDocs = this.getMissingRequiredDocuments();
    if (!missingDocs.length) return true;

    let names = missingDocs.map(x => x.tipoDocumentoNombre).join(", ");
    this.operationFailed(`Debe adjuntar los documentos requeridos: ${names}`);
    return false;
  }
}
